module.exports = __webpack_public_path__ + "media/1100_2_HC_2023_Permissions.bb1a1142.mp4";